module.exports = __webpack_public_path__ + "static/media/vietnamese_hat.0c82543a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/vietnamese_hat.jpg
// module id = 471
// module chunks = 0